import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { capturePortalEvent } from '@lib/monitoring';
import type { PortalBanner } from '@lib/customerPortalContent';

// A merchant announcement banner on the main page. Width is the merchant's percent (full width
// when unset). An image that fails to load hides the banner instead of showing a broken image.
const PortalBannerImage: React.FC<{
  banner: PortalBanner | null;
  position: 'top' | 'bottom';
}> = ({ banner, position }) => {
  const { t } = useTranslation();
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  if (!banner || banner.imageUrl === failedUrl) return null;
  const image = (
    <img
      src={banner.imageUrl}
      alt={t('dashboard.banner.alt')}
      className="block w-full h-auto rounded-[10px]"
      onError={() => setFailedUrl(banner.imageUrl)}
    />
  );
  return (
    <div
      className="mx-auto mb-6"
      style={{ width: banner.sizePercent ? `${banner.sizePercent}%` : '100%' }}
    >
      {banner.link ? (
        <a
          href={banner.link}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            capturePortalEvent('portal_banner_clicked', { position, link: banner.link })
          }
        >
          {image}
        </a>
      ) : (
        image
      )}
    </div>
  );
};

export default PortalBannerImage;
